import { useCallback } from 'react';
import useModal from 'hooks/useModal';
import * as track from 'lib/gaTracking/crossPageEvents';
import { downloadAppleWalletPassErrorModalProps } from './DownloadAppleWalletPassErrorModal';

export const useDownloadAppleWalletPassErrorModal = () => {
  const { showModal } = useModal();

  return useCallback(() => {
    track.appleWalletPassDownloadFailedModalOpened();
    showModal({
      ...downloadAppleWalletPassErrorModalProps,
      onClose: ({ actionButtonClicked }) => {
        track.appleWalletPassDownloadFailedModalClosed(actionButtonClicked);
      },
    });
  }, [showModal]);
};
